import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _extends from "@babel/runtime/helpers/extends";
var _excluded = ["children", "theme"],
    _excluded2 = ["label", "theme"],
    _excluded3 = ["maxLinks", "overflowLabel", "mini", "children", "theme"],
    _excluded4 = ["theme", "children"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React from 'react';
import styled, { withTheme } from 'styled-components';
import PropTypes from 'prop-types';
import { DropdownMenu } from '../Popover';
import MenuList, { Item } from '../MenuList';
import Box from '../Box';
import Text from '../Text';
import More from '../Icons/MoreIcon';
import Hamburger from '../Hamburger';
import { useThemeDefaults, isFunction } from '../utils';
import { focusVisibleStyle } from '../focus';
import { cursor } from '../theme';
import { MiniOverlay, MiniLink } from './MiniOverlay';
var MiniLinkIcons = withTheme(function (_ref) {
  var theme = _ref.theme,
      isOverlayVisible = _ref.isOverlayVisible;
  return /*#__PURE__*/React.createElement(Hamburger, {
    opened: isOverlayVisible,
    size: theme.topHeader.iconSizeNum
  });
});
var MiniLinksDropdown = withTheme(function (_ref2) {
  var children = _ref2.children,
      theme = _ref2.theme,
      hideOverlay = _ref2.hideOverlay;
  return /*#__PURE__*/React.createElement("ul", {
    role: "navigation"
  }, children.map(function (link) {
    return /*#__PURE__*/React.createElement(Box, {
      as: "li",
      key: link.key,
      borderBottom: theme.topHeader.miniLinksBorderBottom,
      borderColor: theme.topHeader.miniLinksBorderColor,
      display: "flex",
      alignItems: "center"
    }, /*#__PURE__*/React.createElement(MiniLink, _extends({}, link.props, {
      onClick: function onClick(e) {
        hideOverlay(e);

        if (isFunction(link.props.onClick)) {
          link.props.onClick(e);
        }
      }
    })));
  }));
});

var _ref4 = /*#__PURE__*/React.createElement(MiniLinkIcons, null);

var MiniLinks = withTheme(function (_ref3) {
  var children = _ref3.children,
      theme = _ref3.theme,
      props = _objectWithoutProperties(_ref3, _excluded);

  return /*#__PURE__*/React.createElement(MiniOverlay, _extends({
    zIndex: 1
  }, props, {
    controlButton: _ref4,
    overlayContent: /*#__PURE__*/React.createElement(MiniLinksDropdown, null, React.Children.toArray(children)),
    overlayStyles: {
      bg: theme.colors.footerBg,
      top: theme.topHeader.height
    }
  }));
});
var PlainButton = styled('button').withConfig({
  displayName: "Links__PlainButton",
  componentId: "sc-10yd502-0"
})(focusVisibleStyle, cursor);
var MoreButton = /*#__PURE__*/React.forwardRef(function (_ref5, ref) {
  var label = _ref5.label,
      theme = _ref5.theme,
      props = _objectWithoutProperties(_ref5, _excluded2);

  return /*#__PURE__*/React.createElement(PlainButton, _extends({
    "aria-label": label,
    cursor: "pointer"
  }, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement(More, {
    width: theme.topHeader.moreSize,
    height: theme.topHeader.moreSize
  }));
});
var popoverModifiers = {
  preventOverflow: {
    enabled: true,
    boundariesElement: 'viewport'
  },
  flip: {
    enabled: false
  }
};
export var LinksOverflow = withTheme(function (_ref6) {
  var overflowLinks = _ref6.overflowLinks,
      overflowLabel = _ref6.overflowLabel,
      theme = _ref6.theme;
  return /*#__PURE__*/React.createElement(DropdownMenu, {
    containerProps: {
      as: 'li',
      display: 'flex'
    },
    target: function target(_ref7) {
      var targetProps = _ref7.targetProps;
      return /*#__PURE__*/React.createElement(MoreButton, _extends({
        label: overflowLabel,
        theme: theme
      }, targetProps));
    },
    popperProps: {
      modifiers: popoverModifiers
    }
  }, function () {
    return /*#__PURE__*/React.createElement(MenuList, null, overflowLinks.map(function (link, i) {
      return /*#__PURE__*/React.createElement(Item, _extends({
        as: "a",
        key: i
      }, link.props));
    }));
  });
});
export var Links = withTheme(function (_ref8) {
  var _ref8$maxLinks = _ref8.maxLinks,
      maxLinks = _ref8$maxLinks === void 0 ? 6 : _ref8$maxLinks,
      _ref8$overflowLabel = _ref8.overflowLabel,
      overflowLabel = _ref8$overflowLabel === void 0 ? 'More links' : _ref8$overflowLabel,
      _ref8$mini = _ref8.mini,
      mini = _ref8$mini === void 0 ? false : _ref8$mini,
      children = _ref8.children,
      theme = _ref8.theme,
      props = _objectWithoutProperties(_ref8, _excluded3);

  var links = React.Children.toArray(children);
  return mini ? /*#__PURE__*/React.createElement(MiniLinks, _extends({
    flex: "0 1 auto"
  }, props), links) : /*#__PURE__*/React.createElement(Box, _extends({
    role: "navigation",
    as: "ul",
    display: "flex",
    flex: "1 0 auto",
    justifyContent: "space-around",
    alignItems: "center",
    alignContent: "baseline"
  }, props), links.length > maxLinks ? links.reduce(function (acc, link, index) {
    return index < maxLinks - 1 ? [].concat(_toConsumableArray(acc), [link]) : index === maxLinks ? [].concat(_toConsumableArray(acc), [/*#__PURE__*/React.createElement(LinksOverflow, {
      key: "overflow",
      overflowLinks: links.slice(maxLinks - 1),
      overflowLabel: overflowLabel
    })]) : acc;
  }, []) : links);
});
process.env.NODE_ENV !== "production" ? Links.propTypes = _objectSpread({
  children: PropTypes.arrayOf(PropTypes.element).isRequired
}, Box.propTypes) : void 0;
export var InnerLink = useThemeDefaults(function (_ref9) {
  var theme = _ref9.theme,
      active = _ref9.active;
  return {
    as: "a",
    display: "block",
    textAlign: "center",
    textStyle: active ? theme.topHeader.linkActiveTextStyle : theme.topHeader.linkTextStyle,
    color: active ? theme.topHeader.activeColor : theme.topHeader.color
  };
}, styled(Text).withConfig({
  displayName: "Links__InnerLink",
  componentId: "sc-10yd502-1"
})(focusVisibleStyle, function (props) {
  return {
    ":hover,:focus": {
      color: props.theme.colors[props.hoverColor] || props.theme.colors.navLabelHover
    }
  };
}));
export var Link = withTheme(function (_ref10) {
  var theme = _ref10.theme,
      children = _ref10.children,
      props = _objectWithoutProperties(_ref10, _excluded4);

  return /*#__PURE__*/React.createElement(Text, {
    role: "menuitem",
    as: "li",
    px: theme.topHeader.marginX
  }, /*#__PURE__*/React.createElement(InnerLink, props, children));
});
Link.propTypes = _objectSpread(_objectSpread({}, Text.propTypes), {}, {
  active: PropTypes.bool
});